import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import Card from 'ui/cards/Card'
import Logo from 'widgets/branding/Logo'
import { PageTitle } from '@morningtrain/react-app'
import Link from 'ui/buttons/Link'
import { WhenRouteIsNot } from '@morningtrain/react-navigation'
import { Translation } from '@morningtrain/react-translations'

export default function Auth (props) {
    return (

        <div className='min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8'>
            <div className='sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center'>
                <div className='w-60'>
                    <Logo className='w-full h-auto block' />
                </div>
                <h2 className='mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900'>
                    <PageTitle />
                </h2>
            </div>

            <div className='mt-8 mx-4 sm:mx-auto sm:w-full sm:max-w-md'>

                <WhenRouteIsNot route='app.auth.login'>
                    <div className='mb-2'>
                        <Link route='app.auth.login'>
                            <Translation name='auth.actions.back_to_login' />
                        </Link>
                    </div>
                </WhenRouteIsNot>

                <Card>
                    <Errors.Boundary>
                        {props.children}
                    </Errors.Boundary>
                </Card>
            </div>

        </div>
    )
}
